import { render } from "./D3BarChart.vue?vue&type=template&id=d3f6cca8"
import script from "./D3BarChart.vue?vue&type=script&lang=js"
export * from "./D3BarChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__